import React, { useState, useEffect } from "react";
import { Link, useParams, useLocation } from "react-router-dom";
// import { Dropdown, Badge, OverlayTrigger, Tooltip } from "react-bootstrap";
import AppContext from "contexts/AppContext";
import auth from "services/auth";
import { __ } from "services/Translator";

import ls from "services/ls";
import { Dropdown, Accordion, OverlayTrigger, Tooltip } from "react-bootstrap";
import ThemeSettings from "./ThemeSettings";
import LanguageSwitcherAccordion from "elements/LanguageSwitcherAccordion";

export default function LeftSidebarShortLong(props) {
  const params = useParams();
  const { updateUserObj } = React.useContext(AppContext);
  const [isAuthenticated, setIsAuthenticated] = useState(auth.isAuthenticated);
  const tab = params.tab;
  const [activeTab, setActiveTab] = useState("account-details");
  const location = useLocation();
  const activeMenu = location.pathname;
  //   alert(props.openLeftSidebar);
  // const showSidebar = props.showLeftSidebar;
  // const setShowSidebar = props.setShowLeftSidebar;
  const [showSidebar, setShowSidebar] = useState(props.showLeftSidebar);

  const logout = async () => {
    await auth.logout();
    await updateUserObj();
    setIsAuthenticated(auth.isAuthenticated);
  };

  const [animationStarts, setAnimationStarts] = useState(false);
  useEffect(() => {
    if (props.showLeftSidebar) {
      setShowSidebar(props.showLeftSidebar);
      setAnimationStarts(true);
      setTimeout(function () {
        setAnimationStarts(false);
      }, 3000);
    }
  }, [props]);

  const [showBalanceAsFiat, setShowBalanceAsFiat] = useState(
    ls.get("showBalanceAsFiat") ? ls.get("showBalanceAsFiat") : false
  );

  const [fiatCurrencyToDisplay, setFiatCurrencyToDisplay] = useState(
    ls.get("fiatCurrencyToDisplay") ? ls.get("fiatCurrencyToDisplay") : "USD"
  );

  useEffect(() => {
    setShowBalanceAsFiat(
      ls.get("showBalanceAsFiat") ? ls.get("showBalanceAsFiat") : false
    );
    setFiatCurrencyToDisplay(
      ls.get("fiatCurrencyToDisplay") ? ls.get("fiatCurrencyToDisplay") : "USD"
    );
  }, [props.trigger]);

  return (
    <>
      {/* <div className="navSidebar fullHide opend"> */}
      <div
        className={
          "navSidebar " +
          (props.showLeftSidebar
            ? "opend inFull"
            : props.isMobileDevice
            ? "fullHide mobleDevice"
            : "inShort ")
        }
      >
        <div className="navSidebarContent">
          <div className="leftSideHeading">
            <div
              onClick={() => {
                props.setShowLeftSidebar(!props.showLeftSidebar);
              }}
              className="actionBar"
            >
              {!props.showLeftSidebar && (
                <svg
                  viewBox="0 0 24 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                  class="m-icon foldOutIcon"
                >
                  <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M5 7a1 1 0 011-1h14a1 1 0 110 2H6a1 1 0 01-1-1zm-2 5a1 1 0 011-1h16a1 1 0 110 2H4a1 1 0 01-1-1zm7 4a1 1 0 100 2h10a1 1 0 100-2H10z"
                    fill="currentColor"
                  ></path>
                </svg>
              )}
              {props.showLeftSidebar && (
                <svg
                  fill="#FF0000"
                  version="1.1"
                  id="Capa_1"
                  xmlns="http://www.w3.org/2000/svg"
                  xlink="http://www.w3.org/1999/xlink"
                  viewBox="0 0 490 490"
                  xml="preserve"
                  className="rotate-center"
                  style={{ width: "22px" }}
                >
                  <g id="SVGRepo_bgCarrier" stroke-width="0"></g>
                  <g
                    id="SVGRepo_tracerCarrier"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  ></g>
                  <g id="SVGRepo_iconCarrier">
                    {" "}
                    <polygon points="456.851,0 245,212.564 33.149,0 0.708,32.337 212.669,245.004 0.708,457.678 33.149,490 245,277.443 456.851,490 489.292,457.678 277.331,245.004 489.292,32.337 "></polygon>{" "}
                  </g>
                </svg>
              )}
            </div>

            <div className="shotSettings slideUpAnimation">
              <ThemeSettings {...props} />
            </div>
          </div>
          <div className="leftSideContent">
            <div className="bottomSideBar ">
              {props.showLeftSidebar && (
                <>
                  <div className="fullOpendMenuItems slideUpAnimation">
                    <div className="left_side_menu_group GDbtnStyle">
                      <Accordion>
                        <Accordion.Item eventKey="0">
                          <Accordion.Header className="casinoGamesBtn">
                            <span className="icon">
                              <img
                                alt=""
                                src={
                                  require("../assets/images/icons/left_sidebar/casino-icon.svg")
                                    .default
                                }
                              />
                            </span>
                            <span className="text">{__("Casino Games")}</span>
                          </Accordion.Header>
                          <Accordion.Body>
                            <div className="dropdownMenu">
                              <Link
                                className={
                                  activeMenu == "/games/slots" ? "active" : ""
                                }
                                to="/games/slots"
                                onClick={() => {
                                  props.setShowLeftSidebar(false);
                                }}
                              >
                                <span className="text">{__("Slot Games")}</span>
                              </Link>
                              <Link
                                className={
                                  activeMenu == "/games/table-games"
                                    ? "active"
                                    : ""
                                }
                                to="/games/table-games"
                                onClick={() => {
                                  props.setShowLeftSidebar(false);
                                }}
                              >
                                <span className="text">
                                  {__("Table Games")}
                                </span>
                              </Link>
                              <Link
                                className={
                                  activeMenu == "/games/bonusbuy"
                                    ? "active"
                                    : ""
                                }
                                to="/games/bonusbuy"
                                onClick={() => {
                                  props.setShowLeftSidebar(false);
                                }}
                              >
                                <span className="text">{__("Bonus Buy")}</span>
                              </Link>
                              <Link
                                className={
                                  activeMenu == "/games/megaways"
                                    ? "active"
                                    : ""
                                }
                                to="/games/megaways"
                                onClick={() => {
                                  props.setShowLeftSidebar(false);
                                }}
                              >
                                <span className="text">{__("Megaways")}</span>
                              </Link>
                              <Link
                                className={
                                  activeMenu == "/games/slots" ? "active" : ""
                                }
                                to="/games/slots"
                                onClick={() => {
                                  props.setShowLeftSidebar(false);
                                }}
                              >
                                <span className="text">
                                  {__("Crash Games")}
                                </span>
                              </Link>
                              <Link
                                className={
                                  activeMenu == "/games/jackpot" ? "active" : ""
                                }
                                to="/games/jackpot"
                                onClick={() => {
                                  props.setShowLeftSidebar(false);
                                }}
                              >
                                <span className="text">
                                  {__("Jackpot Slots")}
                                </span>
                              </Link>
                              <Link
                                className={
                                  activeMenu == "/games/new" ? "active" : ""
                                }
                                to="/games/new"
                                onClick={() => {
                                  props.setShowLeftSidebar(false);
                                }}
                              >
                                <span className="text">{__("New Games")}</span>
                              </Link>
                              <Link
                                className={
                                  activeMenu == "/games/other" ? "active" : ""
                                }
                                to="/games/other"
                                onClick={() => {
                                  props.setShowLeftSidebar(false);
                                }}
                              >
                                <span className="text">{__("Others")}</span>
                              </Link>
                              <Link
                                className={
                                  activeMenu == "/games/all" ? "active" : ""
                                }
                                to="/games/all"
                                onClick={() => {
                                  props.setShowLeftSidebar(false);
                                }}
                              >
                                <span className="text">{__("All Games")}</span>
                              </Link>
                            </div>
                          </Accordion.Body>
                        </Accordion.Item>
                      </Accordion>

                      <Accordion>
                        <Accordion.Item eventKey="0">
                          <Accordion.Header className="liveCasinoGamesBtn">
                            <span className="icon">
                              <img
                                alt=""
                                src={
                                  require("../assets/images/icons/left_sidebar/live-casino-icon.svg")
                                    .default
                                }
                              />
                            </span>
                            <span className="text">{__("Live Casino")}</span>
                          </Accordion.Header>
                          <Accordion.Body>
                            <div className="dropdownMenu">
                              <Link
                                className={
                                  activeMenu == "/games/live-casino"
                                    ? "active"
                                    : ""
                                }
                                to="/games/live-casino"
                                onClick={() => {
                                  props.setShowLeftSidebar(false);
                                }}
                              >
                                <span className="text">{__("Roulette")}</span>
                              </Link>
                              <Link
                                className={
                                  activeMenu == "/games/blackjack"
                                    ? "active"
                                    : ""
                                }
                                to="/games/blackjack"
                                onClick={() => {
                                  props.setShowLeftSidebar(false);
                                }}
                              >
                                <span className="text">{__("Blackjack")}</span>
                              </Link>
                              <Link
                                className={
                                  activeMenu == "/games/baccarat"
                                    ? "active"
                                    : ""
                                }
                                to="/games/baccarat"
                                onClick={() => {
                                  props.setShowLeftSidebar(false);
                                }}
                              >
                                <span className="text">{__("Baccarat")}</span>
                              </Link>
                              <Link
                                className={
                                  activeMenu == "/games/live-show"
                                    ? "active"
                                    : ""
                                }
                                to="/games/live-show"
                                onClick={() => {
                                  props.setShowLeftSidebar(false);
                                }}
                              >
                                <span className="text">{__("Live Shows")}</span>
                              </Link>
                              <Link
                                className={
                                  activeMenu == "/games/craps" ? "active" : ""
                                }
                                to="/games/craps"
                                onClick={() => {
                                  props.setShowLeftSidebar(false);
                                }}
                              >
                                <span className="text">{__("Craps")}</span>
                              </Link>
                              <Link
                                className={
                                  activeMenu == "/games/all-live-games"
                                    ? "active"
                                    : ""
                                }
                                to="/games/all-live-games"
                                onClick={() => {
                                  props.setShowLeftSidebar(false);
                                }}
                              >
                                <span className="text">
                                  {__("All Live Games ")}
                                </span>
                              </Link>
                            </div>
                          </Accordion.Body>
                        </Accordion.Item>
                      </Accordion>
                    </div>
                    <div className="promotion_button_group">
                      <Link
                        to="/rewards"
                        onClick={() => {
                          props.setShowLeftSidebar(false);
                        }}
                        className="commonBtn bonusBtn "
                      >
                        <span className="icon">
                          <img
                            alt=""
                            src={
                              require("../assets/images/icons/left_sidebar/rewards-icon.svg")
                                .default
                            }
                          />
                        </span>
                        <span className="text">{__("Rewards")}</span>
                      </Link>

                      <Link
                        to="/promotions"
                        onClick={() => {
                          props.setShowLeftSidebar(false);
                        }}
                        className="commonBtn bonusBtn "
                      >
                        <span className="icon">
                          <img
                            alt=""
                            style={{ marginTop: "-6px" }}
                            src={
                              require("../assets/images/icons/left_sidebar/promotion-icon.svg")
                                .default
                            }
                          />
                        </span>
                        <span className="text">{__("Promotions")}</span>
                      </Link>
                      <Link
                        to="/races"
                        onClick={() => {
                          props.setShowLeftSidebar(false);
                        }}
                        className="commonBtn bonusBtn "
                      >
                        <span className="icon">
                          <img
                            alt=""
                            style={{ width: "26px", marginTop: "-2px" }}
                            src={
                              require("../assets/images/icons/left_sidebar/race-icon.svg")
                                .default
                            }
                          />
                        </span>
                        <span className="text">{__("Races")}</span>
                      </Link>

                      {props.isAuthenticated && (
                        <>
                          <Link
                            to="/store"
                            onClick={() => {
                              props.setShowLeftSidebar(false);
                            }}
                            className="commonBtn bonusBtn "
                          >
                            <span className="icon">
                              <svg
                                fill="#ffffff"
                                version="1.1"
                                id="Capa_1"
                                xmlns="http://www.w3.org/2000/svg"
                                xlink="http://www.w3.org/1999/xlink"
                                width="20px"
                                height="20px"
                                viewBox="0 0 902.86 902.86"
                                space="preserve"
                              >
                                <g>
                                  <g>
                                    <path
                                      d="M671.504,577.829l110.485-432.609H902.86v-68H729.174L703.128,179.2L0,178.697l74.753,399.129h596.751V577.829z
			 M685.766,247.188l-67.077,262.64H131.199L81.928,246.756L685.766,247.188z"
                                    />
                                    <path
                                      d="M578.418,825.641c59.961,0,108.743-48.783,108.743-108.744s-48.782-108.742-108.743-108.742H168.717
			c-59.961,0-108.744,48.781-108.744,108.742s48.782,108.744,108.744,108.744c59.962,0,108.743-48.783,108.743-108.744
			c0-14.4-2.821-28.152-7.927-40.742h208.069c-5.107,12.59-7.928,26.342-7.928,40.742
			C469.675,776.858,518.457,825.641,578.418,825.641z M209.46,716.897c0,22.467-18.277,40.744-40.743,40.744
			c-22.466,0-40.744-18.277-40.744-40.744c0-22.465,18.277-40.742,40.744-40.742C191.183,676.155,209.46,694.432,209.46,716.897z
			 M619.162,716.897c0,22.467-18.277,40.744-40.743,40.744s-40.743-18.277-40.743-40.744c0-22.465,18.277-40.742,40.743-40.742
			S619.162,694.432,619.162,716.897z"
                                    />
                                  </g>
                                </g>
                              </svg>
                            </span>
                            <span className="text">{__("Store")}</span>
                          </Link>
                        </>
                      )}

                      {!props.isAuthenticated && (
                        <>
                          <Link
                            to="/vip"
                            onClick={() => {
                              props.setShowLeftSidebar(false);
                            }}
                            className="commonBtn bonusBtn "
                          >
                            <span className="icon">
                              <img
                                alt=""
                                style={{ marginTop: "-7px", width: "24px" }}
                                src={
                                  require("../assets/images/icons/left_sidebar/vip-icon.svg")
                                    .default
                                }
                              />
                            </span>
                            <span className="text">{__("VIP & Loyalty")}</span>
                          </Link>
                        </>
                      )}

                      <Link
                        to="/affiliates"
                        onClick={() => {
                          props.setShowLeftSidebar(false);
                        }}
                        className="commonBtn bonusBtn "
                      >
                        <span className="icon">
                          <img
                            alt=""
                            style={{ width: "24px" }}
                            src={
                              require("../assets/images/icons/left_sidebar/affiliates-icon.svg")
                                .default
                            }
                          />
                        </span>
                        <span className="text">{__("Affiliates")}</span>
                      </Link>
                    </div>
                  </div>
                </>
              )}
              {!props.showLeftSidebar && (
                <>
                  <div className="halfOpendMenuItems slideUpAnimation">
                    <div className="promotion_button_group">
                      <OverlayTrigger
                        placement="top"
                        overlay={<Tooltip>{__("Slots")}</Tooltip>}
                      >
                        <Link to="/games/slots" className="commonBtn bonusBtn ">
                          <span className="icon">
                            <img
                              alt=""
                              src={
                                require("../assets/images/icons/left_sidebar/casino-icon.svg")
                                  .default
                              }
                            />
                          </span>
                        </Link>
                      </OverlayTrigger>

                      <OverlayTrigger
                        placement="top"
                        overlay={<Tooltip>{__("Live Casino")}</Tooltip>}
                      >
                        <Link
                          to="/games/live-casino"
                          className="commonBtn bonusBtn "
                        >
                          <span className="icon">
                            <img
                              alt=""
                              src={
                                require("../assets/images/icons/left_sidebar/live-casino-icon.svg")
                                  .default
                              }
                            />
                          </span>
                        </Link>
                      </OverlayTrigger>
                      <OverlayTrigger
                        placement="top"
                        overlay={<Tooltip>{__("Rewards")}</Tooltip>}
                      >
                        <Link to="/rewards" className="commonBtn bonusBtn ">
                          <span className="icon">
                            <img
                              alt=""
                              src={
                                require("../assets/images/icons/left_sidebar/rewards-icon.svg")
                                  .default
                              }
                            />
                          </span>
                        </Link>
                      </OverlayTrigger>
                      <OverlayTrigger
                        placement="top"
                        overlay={<Tooltip>{__("Promotions")}</Tooltip>}
                      >
                        <Link to="/promotions" className="commonBtn bonusBtn ">
                          <span className="icon">
                            <img
                              alt=""
                              style={{ marginTop: "-6px" }}
                              src={
                                require("../assets/images/icons/left_sidebar/promotion-icon.svg")
                                  .default
                              }
                            />
                          </span>
                        </Link>
                      </OverlayTrigger>
                      <OverlayTrigger
                        placement="top"
                        overlay={<Tooltip>{__("Races")}</Tooltip>}
                      >
                        <Link to="/races" className="commonBtn bonusBtn ">
                          <span className="icon">
                            <img
                              alt=""
                              style={{ marginTop: "-2px" }}
                              src={
                                require("../assets/images/icons/left_sidebar/race-icon.svg")
                                  .default
                              }
                            />
                          </span>
                        </Link>
                      </OverlayTrigger>
                      {props.isAuthenticated && (
                        <>
                          <OverlayTrigger
                            placement="top"
                            overlay={<Tooltip>{__("Store")}</Tooltip>}
                          >
                            <Link to="/store" className="commonBtn bonusBtn ">
                              <span className="icon">
                                <svg
                                  fill="#ffffff"
                                  version="1.1"
                                  id="Capa_1"
                                  xmlns="http://www.w3.org/2000/svg"
                                  xlink="http://www.w3.org/1999/xlink"
                                  width="20px"
                                  height="20px"
                                  viewBox="0 0 902.86 902.86"
                                  space="preserve"
                                >
                                  <g>
                                    <g>
                                      <path
                                        d="M671.504,577.829l110.485-432.609H902.86v-68H729.174L703.128,179.2L0,178.697l74.753,399.129h596.751V577.829z
			 M685.766,247.188l-67.077,262.64H131.199L81.928,246.756L685.766,247.188z"
                                      />
                                      <path
                                        d="M578.418,825.641c59.961,0,108.743-48.783,108.743-108.744s-48.782-108.742-108.743-108.742H168.717
			c-59.961,0-108.744,48.781-108.744,108.742s48.782,108.744,108.744,108.744c59.962,0,108.743-48.783,108.743-108.744
			c0-14.4-2.821-28.152-7.927-40.742h208.069c-5.107,12.59-7.928,26.342-7.928,40.742
			C469.675,776.858,518.457,825.641,578.418,825.641z M209.46,716.897c0,22.467-18.277,40.744-40.743,40.744
			c-22.466,0-40.744-18.277-40.744-40.744c0-22.465,18.277-40.742,40.744-40.742C191.183,676.155,209.46,694.432,209.46,716.897z
			 M619.162,716.897c0,22.467-18.277,40.744-40.743,40.744s-40.743-18.277-40.743-40.744c0-22.465,18.277-40.742,40.743-40.742
			S619.162,694.432,619.162,716.897z"
                                      />
                                    </g>
                                  </g>
                                </svg>
                              </span>
                            </Link>
                          </OverlayTrigger>
                        </>
                      )}

                      {!props.isAuthenticated && (
                        <>
                          <OverlayTrigger
                            placement="top"
                            overlay={<Tooltip>{__("VIP & Loyalty")}</Tooltip>}
                          >
                            <Link to="/vip" className="commonBtn bonusBtn ">
                              <span className="icon">
                                <img
                                  alt=""
                                  style={{ marginTop: "-7px" }}
                                  src={
                                    require("../assets/images/icons/left_sidebar/vip-icon.svg")
                                      .default
                                  }
                                />
                              </span>
                            </Link>
                          </OverlayTrigger>
                        </>
                      )}

                      <OverlayTrigger
                        placement="top"
                        overlay={<Tooltip>{__("Affiliates")}</Tooltip>}
                      >
                        <Link to="/affiliates" className="commonBtn bonusBtn ">
                          <span className="icon">
                            <img
                              alt=""
                              src={
                                require("../assets/images/icons/left_sidebar/affiliates-icon.svg")
                                  .default
                              }
                            />
                          </span>
                        </Link>
                      </OverlayTrigger>
                    </div>
                  </div>
                </>
              )}
            </div>
            <div className="bottomSideBar ">
              {props.showLeftSidebar && (
                <div className="fullOpendMenuItems slideUpAnimation">
                  <div className="left_side_menu_group GDbtnStyle">
                    <LanguageSwitcherAccordion {...props} />
                    <div className="promotion_button_group">
                      <Link
                        onClick={() => {
                          props.setIsChatVisible(false);
                          props.setSupportSidebarOpen(
                            !props.supportSidebarOpen
                          );
                          props.setShowRightSidebar(!props.showRightSidebar);
                        }}
                        className="commonBtn bonusBtn "
                      >
                        <span className="icon">
                          <svg
                            viewBox="0 0 512 512"
                            version="1.1"
                            xmlns="http://www.w3.org/2000/svg"
                            xlink="http://www.w3.org/1999/xlink"
                            width="26px"
                          >
                            <title>support</title>
                            <g
                              id="Page-1"
                              stroke="none"
                              stroke-width="1"
                              fill="none"
                              fill-rule="evenodd"
                            >
                              <g
                                id="support"
                                fill="#000000"
                                transform="translate(42.666667, 42.666667)"
                              >
                                <path d="M379.734355,174.506667 C373.121022,106.666667 333.014355,-2.13162821e-14 209.067688,-2.13162821e-14 C85.1210217,-2.13162821e-14 45.014355,106.666667 38.4010217,174.506667 C15.2012632,183.311569 -0.101643453,205.585799 0.000508304259,230.4 L0.000508304259,260.266667 C0.000508304259,293.256475 26.7445463,320 59.734355,320 C92.7241638,320 119.467688,293.256475 119.467688,260.266667 L119.467688,230.4 C119.360431,206.121456 104.619564,184.304973 82.134355,175.146667 C86.4010217,135.893333 107.307688,42.6666667 209.067688,42.6666667 C310.827688,42.6666667 331.521022,135.893333 335.787688,175.146667 C313.347976,184.324806 298.68156,206.155851 298.667688,230.4 L298.667688,260.266667 C298.760356,283.199651 311.928618,304.070103 332.587688,314.026667 C323.627688,330.88 300.801022,353.706667 244.694355,360.533333 C233.478863,343.50282 211.780225,336.789048 192.906491,344.509658 C174.032757,352.230268 163.260418,372.226826 167.196286,392.235189 C171.132153,412.243552 188.675885,426.666667 209.067688,426.666667 C225.181549,426.577424 239.870491,417.417465 247.041022,402.986667 C338.561022,392.533333 367.787688,345.386667 376.961022,317.653333 C401.778455,309.61433 418.468885,286.351502 418.134355,260.266667 L418.134355,230.4 C418.23702,205.585799 402.934114,183.311569 379.734355,174.506667 Z M76.8010217,260.266667 C76.8010217,269.692326 69.1600148,277.333333 59.734355,277.333333 C50.3086953,277.333333 42.6676884,269.692326 42.6676884,260.266667 L42.6676884,230.4 C42.6676884,224.302667 45.9205765,218.668499 51.2010216,215.619833 C56.4814667,212.571166 62.9872434,212.571166 68.2676885,215.619833 C73.5481336,218.668499 76.8010217,224.302667 76.8010217,230.4 L76.8010217,260.266667 Z M341.334355,230.4 C341.334355,220.97434 348.975362,213.333333 358.401022,213.333333 C367.826681,213.333333 375.467688,220.97434 375.467688,230.4 L375.467688,260.266667 C375.467688,269.692326 367.826681,277.333333 358.401022,277.333333 C348.975362,277.333333 341.334355,269.692326 341.334355,260.266667 L341.334355,230.4 Z"></path>
                              </g>
                            </g>
                          </svg>
                        </span>
                        <span className="text">{__("Support")}</span>
                      </Link>
                      <Link
                        onClick={() => {
                          props.setIsChatVisible(!props.isChatVisible);
                          props.setSupportSidebarOpen(false);
                          props.setShowRightSidebar(!props.showRightSidebar);
                        }}
                        className="commonBtn bonusBtn "
                      >
                        <span className="icon">
                          <svg
                            fill="#ffffff"
                            width="20px"
                            version="1.1"
                            id="Capa_1"
                            xmlns="http://www.w3.org/2000/svg"
                            xlink="http://www.w3.org/1999/xlink"
                            viewBox="0 0 484.366 484.366"
                            xml="preserve"
                          >
                            <g>
                              <path
                                d="M483.629,457.833l-7.731-38.872c-3.07-15.4-15.117-27.43-30.517-30.478l-10.474-2.07
		c-6.014-1.188-10.738-5.866-11.998-11.881l-1.982-9.621c-0.647-3.079,0.472-6.269,2.895-8.275
		c9.449-7.826,18.095-19.354,23.133-32.958c6.945-1.253,13.291-7.937,15.338-17.141c2.52-11.401-2.504-22.218-11.211-24.156
		c-0.111-0.015-0.221-0.008-0.316-0.015c-2.628-29.613-14.03-51.54-51.964-51.54c-37.288,0-49.13,21.919-51.917,51.523
		c-0.111,0.023-0.236,0.017-0.362,0.031c-8.724,1.939-13.732,12.755-11.212,24.156c2.046,9.204,8.377,15.888,15.338,17.141
		c5.039,13.612,13.7,25.132,23.131,32.966c2.426,1.999,3.545,5.189,2.914,8.259l-2,9.622c-1.244,6.015-5.968,10.7-12,11.896
		l-10.471,2.063c-15.401,3.048-27.446,15.078-30.518,30.478l-7.732,38.872c-1.29,6.52,0.396,13.282,4.615,18.416
		c4.22,5.141,10.518,8.117,17.163,8.117h126.101c6.647,0,12.945-2.977,17.165-8.117
		C483.236,471.115,484.921,464.353,483.629,457.833z"
                              />
                              <path
                                d="M162.662,418.961c-3.071-15.4-15.116-27.43-30.518-30.478l-10.472-2.07c-6.016-1.188-10.738-5.866-11.999-11.881
		l-1.984-9.621c-0.646-3.079,0.473-6.269,2.898-8.275c9.447-7.826,18.092-19.354,23.131-32.958
		c6.945-1.253,13.292-7.937,15.338-17.141c2.52-11.401-2.504-22.218-11.212-24.156c-0.109-0.015-0.221-0.008-0.314-0.015
		c-2.63-29.613-14.032-51.54-51.966-51.54c-37.288,0-49.13,21.919-51.916,51.523c-0.111,0.023-0.237,0.017-0.363,0.031
		c-8.724,1.939-13.731,12.755-11.212,24.156c2.048,9.204,8.377,15.888,15.339,17.141c5.038,13.612,13.699,25.132,23.133,32.966
		c2.423,1.999,3.542,5.189,2.911,8.259l-1.999,9.622c-1.245,6.015-5.968,10.7-11.999,11.896l-10.473,2.063
		c-15.399,3.048-27.446,15.078-30.516,30.478l-7.733,38.872c-1.292,6.52,0.394,13.282,4.613,18.416
		c4.22,5.141,10.519,8.117,17.165,8.117h126.101c6.646,0,12.943-2.977,17.163-8.117c4.22-5.134,5.905-11.896,4.615-18.416
		L162.662,418.961z"
                              />
                              <path
                                d="M334.491,253.329c1.718-1.686,2.017-4.348,0.74-6.37L317.5,210.78h24.612c12.692,0,22.959-10.267,22.959-22.958V83.773
		c0-12.691-10.267-22.958-22.959-22.958H284.92v66.199c0,24.07-19.574,43.643-43.65,43.643h-67.995l-17.637,11.787v5.378
		c0,12.691,10.282,22.958,22.958,22.958h74.279l75.206,43.146C330.097,255.257,332.775,255.014,334.491,253.329z"
                              />
                              <path
                                d="M77.753,149.974h24.613L84.21,186.404c-1.307,2.032-0.977,4.7,0.74,6.377c0.977,0.962,2.252,1.448,3.559,1.448
		c0.993,0,1.969-0.282,2.835-0.857l75.647-43.398h74.278c12.676,0,22.959-10.291,22.959-22.959V22.959
		C264.229,10.283,253.946,0,241.27,0H77.753C65.062,0,54.795,10.283,54.795,22.959v104.056
		C54.795,139.683,65.062,149.974,77.753,149.974z M205.304,57.815c9.48,0,17.18,7.685,17.18,17.172c0,9.479-7.7,17.164-17.18,17.164
		c-9.48,0-17.165-7.685-17.165-17.164C188.139,65.5,195.824,57.815,205.304,57.815z M159.511,57.815
		c9.479,0,17.165,7.685,17.165,17.172c0,9.479-7.686,17.164-17.165,17.164c-9.479,0-17.18-7.685-17.18-17.164
		C142.332,65.5,150.033,57.815,159.511,57.815z M113.704,57.815c9.513,0,17.181,7.685,17.181,17.172
		c0,9.479-7.668,17.164-17.181,17.164c-9.464,0-17.163-7.685-17.163-17.164C96.541,65.5,104.24,57.815,113.704,57.815z"
                              />
                            </g>
                          </svg>
                        </span>
                        <span className="text">{__("Players forum")}</span>
                      </Link>
                    </div>
                  </div>
                  <div class="buy-crypto-block leftSideBlock">
                    {!props.isAuthenticated && (
                      <Link
                        onClick={() => {
                          props.setModalSignUpPropsData(true);
                          setTimeout(function () {
                            props.setModalSignUpPropsData(false);
                          }, 500);
                        }}
                        className="commonBtn bonusBtn"
                      >
                        <span className="icon">
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            fill="none"
                            viewBox="5.5 3.5 14 17"
                            width="20"
                          >
                            <path
                              fill-rule="evenodd"
                              clip-rule="evenodd"
                              d="M16 3.5C15.1716 3.5 14.5 4.17157 14.5 5C14.5 5.65311 14.9174 6.20873 15.5 6.41465V7.5H7C6.17157 7.5 5.5 8.17157 5.5 9V15C5.5 15.8284 6.17157 16.5 7 16.5H8.5V17.5854C7.9174 17.7913 7.5 18.3469 7.5 19C7.5 19.8284 8.17157 20.5 9 20.5C9.82843 20.5 10.5 19.8284 10.5 19C10.5 18.3469 10.0826 17.7913 9.5 17.5854V16.5H17C17.8284 16.5 18.5 15.8284 18.5 15V13.4146C19.0826 13.2087 19.5 12.6531 19.5 12C19.5 11.3469 19.0826 10.7913 18.5 10.5854V9C18.5 8.17157 17.8284 7.5 17 7.5H16.5V6.41465C17.0826 6.20873 17.5 5.65311 17.5 5C17.5 4.17157 16.8284 3.5 16 3.5ZM15.5 5C15.5 4.72386 15.7239 4.5 16 4.5C16.2761 4.5 16.5 4.72386 16.5 5C16.5 5.27614 16.2761 5.5 16 5.5C15.7239 5.5 15.5 5.27614 15.5 5ZM17.5 10.5V9C17.5 8.72386 17.2761 8.5 17 8.5H7C6.72386 8.5 6.5 8.72386 6.5 9V15C6.5 15.2761 6.72386 15.5 7 15.5H17C17.2761 15.5 17.5 15.2761 17.5 15V13.5H14C13.1716 13.5 12.5 12.8284 12.5 12C12.5 11.1716 13.1716 10.5 14 10.5H17.5ZM9 18.5C8.72386 18.5 8.5 18.7239 8.5 19C8.5 19.2761 8.72386 19.5 9 19.5C9.27614 19.5 9.5 19.2761 9.5 19C9.5 18.7239 9.27614 18.5 9 18.5ZM13.5 12C13.5 11.7239 13.7239 11.5 14 11.5H18C18.2761 11.5 18.5 11.7239 18.5 12C18.5 12.2761 18.2761 12.5 18 12.5H14C13.7239 12.5 13.5 12.2761 13.5 12Z"
                              fill="#47495F"
                            />
                          </svg>
                        </span>
                        <span className="text">
                          {__("Sign Up & Buy Crypto")}
                        </span>
                      </Link>
                    )}

                    {props.isAuthenticated && (
                      <Link
                        onClick={() => {
                          props.setOpenWalletModalTab("deposit");
                        }}
                        className="commonBtn bonusBtn"
                      >
                        <span className="icon">
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            fill="none"
                            viewBox="5.5 3.5 14 17"
                            width="20"
                          >
                            <path
                              fill-rule="evenodd"
                              clip-rule="evenodd"
                              d="M16 3.5C15.1716 3.5 14.5 4.17157 14.5 5C14.5 5.65311 14.9174 6.20873 15.5 6.41465V7.5H7C6.17157 7.5 5.5 8.17157 5.5 9V15C5.5 15.8284 6.17157 16.5 7 16.5H8.5V17.5854C7.9174 17.7913 7.5 18.3469 7.5 19C7.5 19.8284 8.17157 20.5 9 20.5C9.82843 20.5 10.5 19.8284 10.5 19C10.5 18.3469 10.0826 17.7913 9.5 17.5854V16.5H17C17.8284 16.5 18.5 15.8284 18.5 15V13.4146C19.0826 13.2087 19.5 12.6531 19.5 12C19.5 11.3469 19.0826 10.7913 18.5 10.5854V9C18.5 8.17157 17.8284 7.5 17 7.5H16.5V6.41465C17.0826 6.20873 17.5 5.65311 17.5 5C17.5 4.17157 16.8284 3.5 16 3.5ZM15.5 5C15.5 4.72386 15.7239 4.5 16 4.5C16.2761 4.5 16.5 4.72386 16.5 5C16.5 5.27614 16.2761 5.5 16 5.5C15.7239 5.5 15.5 5.27614 15.5 5ZM17.5 10.5V9C17.5 8.72386 17.2761 8.5 17 8.5H7C6.72386 8.5 6.5 8.72386 6.5 9V15C6.5 15.2761 6.72386 15.5 7 15.5H17C17.2761 15.5 17.5 15.2761 17.5 15V13.5H14C13.1716 13.5 12.5 12.8284 12.5 12C12.5 11.1716 13.1716 10.5 14 10.5H17.5ZM9 18.5C8.72386 18.5 8.5 18.7239 8.5 19C8.5 19.2761 8.72386 19.5 9 19.5C9.27614 19.5 9.5 19.2761 9.5 19C9.5 18.7239 9.27614 18.5 9 18.5ZM13.5 12C13.5 11.7239 13.7239 11.5 14 11.5H18C18.2761 11.5 18.5 11.7239 18.5 12C18.5 12.2761 18.2761 12.5 18 12.5H14C13.7239 12.5 13.5 12.2761 13.5 12Z"
                              fill="#47495F"
                            />
                          </svg>
                        </span>
                        <span className="text">
                          {__("Buy Crypto | Deposit")}
                        </span>
                      </Link>
                    )}
                    <div class="buy-crypto-block__methods">
                      <div class="buy-crypto-block__method">
                        <img
                          src={require("assets/images/icons/gpay.webp").default}
                          alt="Google Pay"
                        />
                      </div>
                      <div class="buy-crypto-block__method">
                        <img
                          src={
                            require("assets/images/icons/applepay.webp").default
                          }
                          alt="Apple Pay"
                        />
                      </div>
                      <div class="buy-crypto-block__method">
                        <img
                          src={
                            require("assets/images/icons/mastercard.webp")
                              .default
                          }
                          alt="Mastercard"
                        />
                      </div>
                      <div class="buy-crypto-block__method">
                        <img
                          src={require("assets/images/icons/visa.webp").default}
                          alt="Visa"
                        />
                      </div>
                    </div>
                  </div>
                </div>
              )}
              {!props.showLeftSidebar && (
                <div className="fullOpendMenuItems slideUpAnimation">
                  <div className="left_side_menu_group GDbtnStyle">
                    <LanguageSwitcherAccordion {...props} />
                    <div className="promotion_button_group">
                      <OverlayTrigger
                        placement="top"
                        overlay={<Tooltip>{__("Support")}</Tooltip>}
                      >
                        <Link
                          onClick={() => {
                            props.setIsChatVisible(false);
                            props.setSupportSidebarOpen(
                              !props.supportSidebarOpen
                            );
                            props.setShowRightSidebar(!props.showRightSidebar);
                          }}
                          className="commonBtn bonusBtn "
                        >
                          <span className="icon">
                            <svg
                              viewBox="0 0 512 512"
                              version="1.1"
                              xmlns="http://www.w3.org/2000/svg"
                              xlink="http://www.w3.org/1999/xlink"
                              width="24px"
                            >
                              <title>support</title>
                              <g
                                id="Page-1"
                                stroke="none"
                                stroke-width="1"
                                fill="none"
                                fill-rule="evenodd"
                              >
                                <g
                                  id="support"
                                  fill="#000000"
                                  transform="translate(42.666667, 42.666667)"
                                >
                                  <path d="M379.734355,174.506667 C373.121022,106.666667 333.014355,-2.13162821e-14 209.067688,-2.13162821e-14 C85.1210217,-2.13162821e-14 45.014355,106.666667 38.4010217,174.506667 C15.2012632,183.311569 -0.101643453,205.585799 0.000508304259,230.4 L0.000508304259,260.266667 C0.000508304259,293.256475 26.7445463,320 59.734355,320 C92.7241638,320 119.467688,293.256475 119.467688,260.266667 L119.467688,230.4 C119.360431,206.121456 104.619564,184.304973 82.134355,175.146667 C86.4010217,135.893333 107.307688,42.6666667 209.067688,42.6666667 C310.827688,42.6666667 331.521022,135.893333 335.787688,175.146667 C313.347976,184.324806 298.68156,206.155851 298.667688,230.4 L298.667688,260.266667 C298.760356,283.199651 311.928618,304.070103 332.587688,314.026667 C323.627688,330.88 300.801022,353.706667 244.694355,360.533333 C233.478863,343.50282 211.780225,336.789048 192.906491,344.509658 C174.032757,352.230268 163.260418,372.226826 167.196286,392.235189 C171.132153,412.243552 188.675885,426.666667 209.067688,426.666667 C225.181549,426.577424 239.870491,417.417465 247.041022,402.986667 C338.561022,392.533333 367.787688,345.386667 376.961022,317.653333 C401.778455,309.61433 418.468885,286.351502 418.134355,260.266667 L418.134355,230.4 C418.23702,205.585799 402.934114,183.311569 379.734355,174.506667 Z M76.8010217,260.266667 C76.8010217,269.692326 69.1600148,277.333333 59.734355,277.333333 C50.3086953,277.333333 42.6676884,269.692326 42.6676884,260.266667 L42.6676884,230.4 C42.6676884,224.302667 45.9205765,218.668499 51.2010216,215.619833 C56.4814667,212.571166 62.9872434,212.571166 68.2676885,215.619833 C73.5481336,218.668499 76.8010217,224.302667 76.8010217,230.4 L76.8010217,260.266667 Z M341.334355,230.4 C341.334355,220.97434 348.975362,213.333333 358.401022,213.333333 C367.826681,213.333333 375.467688,220.97434 375.467688,230.4 L375.467688,260.266667 C375.467688,269.692326 367.826681,277.333333 358.401022,277.333333 C348.975362,277.333333 341.334355,269.692326 341.334355,260.266667 L341.334355,230.4 Z"></path>
                                </g>
                              </g>
                            </svg>
                          </span>
                          <span className="text">{__("Support")}</span>
                        </Link>
                      </OverlayTrigger>
                      <OverlayTrigger
                        placement="top"
                        overlay={<Tooltip>{__("Players Forum")}</Tooltip>}
                      >
                        <Link
                          onClick={() => {
                            props.setIsChatVisible(!props.isChatVisible);
                            props.setSupportSidebarOpen(false);
                            props.setShowRightSidebar(!props.showRightSidebar);
                          }}
                          className="commonBtn bonusBtn "
                        >
                          <span className="icon">
                            <svg
                              fill="#ffffff"
                              width="20px"
                              version="1.1"
                              id="Capa_1"
                              xmlns="http://www.w3.org/2000/svg"
                              xlink="http://www.w3.org/1999/xlink"
                              viewBox="0 0 484.366 484.366"
                              xml="preserve"
                            >
                              <g>
                                <path
                                  d="M483.629,457.833l-7.731-38.872c-3.07-15.4-15.117-27.43-30.517-30.478l-10.474-2.07
		c-6.014-1.188-10.738-5.866-11.998-11.881l-1.982-9.621c-0.647-3.079,0.472-6.269,2.895-8.275
		c9.449-7.826,18.095-19.354,23.133-32.958c6.945-1.253,13.291-7.937,15.338-17.141c2.52-11.401-2.504-22.218-11.211-24.156
		c-0.111-0.015-0.221-0.008-0.316-0.015c-2.628-29.613-14.03-51.54-51.964-51.54c-37.288,0-49.13,21.919-51.917,51.523
		c-0.111,0.023-0.236,0.017-0.362,0.031c-8.724,1.939-13.732,12.755-11.212,24.156c2.046,9.204,8.377,15.888,15.338,17.141
		c5.039,13.612,13.7,25.132,23.131,32.966c2.426,1.999,3.545,5.189,2.914,8.259l-2,9.622c-1.244,6.015-5.968,10.7-12,11.896
		l-10.471,2.063c-15.401,3.048-27.446,15.078-30.518,30.478l-7.732,38.872c-1.29,6.52,0.396,13.282,4.615,18.416
		c4.22,5.141,10.518,8.117,17.163,8.117h126.101c6.647,0,12.945-2.977,17.165-8.117
		C483.236,471.115,484.921,464.353,483.629,457.833z"
                                />
                                <path
                                  d="M162.662,418.961c-3.071-15.4-15.116-27.43-30.518-30.478l-10.472-2.07c-6.016-1.188-10.738-5.866-11.999-11.881
		l-1.984-9.621c-0.646-3.079,0.473-6.269,2.898-8.275c9.447-7.826,18.092-19.354,23.131-32.958
		c6.945-1.253,13.292-7.937,15.338-17.141c2.52-11.401-2.504-22.218-11.212-24.156c-0.109-0.015-0.221-0.008-0.314-0.015
		c-2.63-29.613-14.032-51.54-51.966-51.54c-37.288,0-49.13,21.919-51.916,51.523c-0.111,0.023-0.237,0.017-0.363,0.031
		c-8.724,1.939-13.731,12.755-11.212,24.156c2.048,9.204,8.377,15.888,15.339,17.141c5.038,13.612,13.699,25.132,23.133,32.966
		c2.423,1.999,3.542,5.189,2.911,8.259l-1.999,9.622c-1.245,6.015-5.968,10.7-11.999,11.896l-10.473,2.063
		c-15.399,3.048-27.446,15.078-30.516,30.478l-7.733,38.872c-1.292,6.52,0.394,13.282,4.613,18.416
		c4.22,5.141,10.519,8.117,17.165,8.117h126.101c6.646,0,12.943-2.977,17.163-8.117c4.22-5.134,5.905-11.896,4.615-18.416
		L162.662,418.961z"
                                />
                                <path
                                  d="M334.491,253.329c1.718-1.686,2.017-4.348,0.74-6.37L317.5,210.78h24.612c12.692,0,22.959-10.267,22.959-22.958V83.773
		c0-12.691-10.267-22.958-22.959-22.958H284.92v66.199c0,24.07-19.574,43.643-43.65,43.643h-67.995l-17.637,11.787v5.378
		c0,12.691,10.282,22.958,22.958,22.958h74.279l75.206,43.146C330.097,255.257,332.775,255.014,334.491,253.329z"
                                />
                                <path
                                  d="M77.753,149.974h24.613L84.21,186.404c-1.307,2.032-0.977,4.7,0.74,6.377c0.977,0.962,2.252,1.448,3.559,1.448
		c0.993,0,1.969-0.282,2.835-0.857l75.647-43.398h74.278c12.676,0,22.959-10.291,22.959-22.959V22.959
		C264.229,10.283,253.946,0,241.27,0H77.753C65.062,0,54.795,10.283,54.795,22.959v104.056
		C54.795,139.683,65.062,149.974,77.753,149.974z M205.304,57.815c9.48,0,17.18,7.685,17.18,17.172c0,9.479-7.7,17.164-17.18,17.164
		c-9.48,0-17.165-7.685-17.165-17.164C188.139,65.5,195.824,57.815,205.304,57.815z M159.511,57.815
		c9.479,0,17.165,7.685,17.165,17.172c0,9.479-7.686,17.164-17.165,17.164c-9.479,0-17.18-7.685-17.18-17.164
		C142.332,65.5,150.033,57.815,159.511,57.815z M113.704,57.815c9.513,0,17.181,7.685,17.181,17.172
		c0,9.479-7.668,17.164-17.181,17.164c-9.464,0-17.163-7.685-17.163-17.164C96.541,65.5,104.24,57.815,113.704,57.815z"
                                />
                              </g>
                            </svg>
                          </span>
                          <span className="text">{__("Players forum")}</span>
                        </Link>
                      </OverlayTrigger>
                    </div>
                  </div>
                  <div class="buy-crypto-block leftSideBlock">
                    {!props.isAuthenticated && (
                      <OverlayTrigger
                        placement="top"
                        overlay={<Tooltip>{__("Buy Crypto")}</Tooltip>}
                      >
                        <Link
                          onClick={() => {
                            props.setModalSignUpPropsData(true);
                            setTimeout(function () {
                              props.setModalSignUpPropsData(false);
                            }, 500);
                          }}
                          className="commonBtn bonusBtn"
                        >
                          <span className="icon">
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              fill="none"
                              viewBox="5.5 3.5 14 17"
                              width="20"
                            >
                              <path
                                fill-rule="evenodd"
                                clip-rule="evenodd"
                                d="M16 3.5C15.1716 3.5 14.5 4.17157 14.5 5C14.5 5.65311 14.9174 6.20873 15.5 6.41465V7.5H7C6.17157 7.5 5.5 8.17157 5.5 9V15C5.5 15.8284 6.17157 16.5 7 16.5H8.5V17.5854C7.9174 17.7913 7.5 18.3469 7.5 19C7.5 19.8284 8.17157 20.5 9 20.5C9.82843 20.5 10.5 19.8284 10.5 19C10.5 18.3469 10.0826 17.7913 9.5 17.5854V16.5H17C17.8284 16.5 18.5 15.8284 18.5 15V13.4146C19.0826 13.2087 19.5 12.6531 19.5 12C19.5 11.3469 19.0826 10.7913 18.5 10.5854V9C18.5 8.17157 17.8284 7.5 17 7.5H16.5V6.41465C17.0826 6.20873 17.5 5.65311 17.5 5C17.5 4.17157 16.8284 3.5 16 3.5ZM15.5 5C15.5 4.72386 15.7239 4.5 16 4.5C16.2761 4.5 16.5 4.72386 16.5 5C16.5 5.27614 16.2761 5.5 16 5.5C15.7239 5.5 15.5 5.27614 15.5 5ZM17.5 10.5V9C17.5 8.72386 17.2761 8.5 17 8.5H7C6.72386 8.5 6.5 8.72386 6.5 9V15C6.5 15.2761 6.72386 15.5 7 15.5H17C17.2761 15.5 17.5 15.2761 17.5 15V13.5H14C13.1716 13.5 12.5 12.8284 12.5 12C12.5 11.1716 13.1716 10.5 14 10.5H17.5ZM9 18.5C8.72386 18.5 8.5 18.7239 8.5 19C8.5 19.2761 8.72386 19.5 9 19.5C9.27614 19.5 9.5 19.2761 9.5 19C9.5 18.7239 9.27614 18.5 9 18.5ZM13.5 12C13.5 11.7239 13.7239 11.5 14 11.5H18C18.2761 11.5 18.5 11.7239 18.5 12C18.5 12.2761 18.2761 12.5 18 12.5H14C13.7239 12.5 13.5 12.2761 13.5 12Z"
                                fill="#47495F"
                              />
                            </svg>
                          </span>
                          <span className="text">
                            {__("Sign Up & Buy Crypto")}
                          </span>
                        </Link>
                      </OverlayTrigger>
                    )}

                    {props.isAuthenticated && (
                      <OverlayTrigger
                        placement="top"
                        overlay={<Tooltip>{__("Buy Crypto")}</Tooltip>}
                      >
                        <Link
                          onClick={() => {
                            props.setOpenWalletModalTab("deposit");
                          }}
                          className="commonBtn bonusBtn"
                        >
                          <span className="icon">
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              fill="none"
                              viewBox="5.5 3.5 14 17"
                              width="20"
                            >
                              <path
                                fill-rule="evenodd"
                                clip-rule="evenodd"
                                d="M16 3.5C15.1716 3.5 14.5 4.17157 14.5 5C14.5 5.65311 14.9174 6.20873 15.5 6.41465V7.5H7C6.17157 7.5 5.5 8.17157 5.5 9V15C5.5 15.8284 6.17157 16.5 7 16.5H8.5V17.5854C7.9174 17.7913 7.5 18.3469 7.5 19C7.5 19.8284 8.17157 20.5 9 20.5C9.82843 20.5 10.5 19.8284 10.5 19C10.5 18.3469 10.0826 17.7913 9.5 17.5854V16.5H17C17.8284 16.5 18.5 15.8284 18.5 15V13.4146C19.0826 13.2087 19.5 12.6531 19.5 12C19.5 11.3469 19.0826 10.7913 18.5 10.5854V9C18.5 8.17157 17.8284 7.5 17 7.5H16.5V6.41465C17.0826 6.20873 17.5 5.65311 17.5 5C17.5 4.17157 16.8284 3.5 16 3.5ZM15.5 5C15.5 4.72386 15.7239 4.5 16 4.5C16.2761 4.5 16.5 4.72386 16.5 5C16.5 5.27614 16.2761 5.5 16 5.5C15.7239 5.5 15.5 5.27614 15.5 5ZM17.5 10.5V9C17.5 8.72386 17.2761 8.5 17 8.5H7C6.72386 8.5 6.5 8.72386 6.5 9V15C6.5 15.2761 6.72386 15.5 7 15.5H17C17.2761 15.5 17.5 15.2761 17.5 15V13.5H14C13.1716 13.5 12.5 12.8284 12.5 12C12.5 11.1716 13.1716 10.5 14 10.5H17.5ZM9 18.5C8.72386 18.5 8.5 18.7239 8.5 19C8.5 19.2761 8.72386 19.5 9 19.5C9.27614 19.5 9.5 19.2761 9.5 19C9.5 18.7239 9.27614 18.5 9 18.5ZM13.5 12C13.5 11.7239 13.7239 11.5 14 11.5H18C18.2761 11.5 18.5 11.7239 18.5 12C18.5 12.2761 18.2761 12.5 18 12.5H14C13.7239 12.5 13.5 12.2761 13.5 12Z"
                                fill="#47495F"
                              />
                            </svg>
                          </span>
                          <span className="text">
                            {__("Buy Crypto | Deposit")}
                          </span>
                        </Link>
                      </OverlayTrigger>
                    )}

                    <div class="buy-crypto-block__methods">
                      <div class="buy-crypto-block__method">
                        <img
                          src={require("assets/images/icons/gpay.webp").default}
                          alt="Google Pay"
                        />
                      </div>
                      <div class="buy-crypto-block__method">
                        <img
                          src={
                            require("assets/images/icons/applepay.webp").default
                          }
                          alt="Apple Pay"
                        />
                      </div>
                      <div class="buy-crypto-block__method">
                        <img
                          src={
                            require("assets/images/icons/mastercard.webp")
                              .default
                          }
                          alt="Mastercard"
                        />
                      </div>
                      <div class="buy-crypto-block__method">
                        <img
                          src={require("assets/images/icons/visa.webp").default}
                          alt="Visa"
                        />
                      </div>
                    </div>
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>

      {showSidebar && (
        <div
          className="invisible_overlay"
          onClick={() => setShowSidebar(false)}
        ></div>
      )}
    </>
  );
}
